import { render, staticRenderFns } from "./VaSelect.vue?vue&type=template&id=285131ab&scoped=true&"
import script from "./VaSelect.vue?vue&type=script&scoped=true&lang=js&"
export * from "./VaSelect.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./VaSelect.vue?vue&type=style&index=0&id=285131ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285131ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
